export const tags = [
    { label: 'Keywords', id: 'keywords' },
    { label: 'Market Share', id: 'market_share' },
    { label: 'Content Gaps', id: 'content_gaps' },
    { label: 'URLs', id: 'urls' },
    { label: 'Opportunities', id: 'opportunities' },
];
